module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.part.content),
      expression: "part.content"
    }],
    ref: "h2",
    attrs: {
      "data-gramm": "false",
      "placeholder": "Type something",
      "disabled": _vm.state !== 'editor'
    },
    domProps: {
      "value": (_vm.part.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.part, "content", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd2cc78","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/h2.vue
// module id = 541
// module chunks = 0